import { render, staticRenderFns } from "./BaseAddListItem.vue?vue&type=template&id=50841478&scoped=true"
import script from "./BaseAddListItem.vue?vue&type=script&lang=js"
export * from "./BaseAddListItem.vue?vue&type=script&lang=js"
import style0 from "./BaseAddListItem.vue?vue&type=style&index=0&id=50841478&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50841478",
  null
  
)

export default component.exports